/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `new` - Nowe
 * * `reviewed` - Rozpatrzone
 * * `withdrawn` - Wycofane
 */
export type ActivationSubmissionStateEnum = typeof ActivationSubmissionStateEnum[keyof typeof ActivationSubmissionStateEnum];


export const ActivationSubmissionStateEnum = {
  new: 'new',
  reviewed: 'reviewed',
  withdrawn: 'withdrawn',
} as const;
